import { useEffect, useState, useCallback } from "react";
import { RefreshCw } from "lucide-react";
import { SectionHead, GhostButton, fmtTs } from "./shared";

const ACTION_LABEL = {
  "role.create": "Sub-role created", "role.update": "Sub-role updated", "role.delete": "Sub-role deleted",
  "matrix.set": "Matrix cell changed", "member.add": "Pioneer added", "member.update": "Pioneer updated",
  "member.remove": "Pioneer removed", "member.revoke": "Access revoked", "member.reinstate": "Access reinstated",
  "override.set": "Override set", "override.clear": "Override cleared",
};
const fmtVal = (v) => (v == null ? "—" : typeof v === "object" ? Object.entries(v).map(([k, x]) => `${k}: ${x ?? "—"}`).join(", ") : String(v));

export function AccessLog({ api, refreshKey }) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const load = useCallback(() => {
    setLoading(true);
    api.get("/admin/pioneers/logs?limit=100").then((r) => { setRows(r.data.items || []); setTotal(r.data.total || 0); }).catch(() => {}).finally(() => setLoading(false));
  }, [api]);
  useEffect(() => { load(); }, [load, refreshKey]);

  return (
    <section className="admin-card" data-testid="pioneer-access-log">
      <SectionHead kicker="Access log" title={`Permission changes · ${total}`}
        action={<GhostButton testid="pioneer-log-refresh" onClick={load} disabled={loading}><RefreshCw size={13} className={loading ? "animate-spin" : ""} /> Refresh</GhostButton>} />
      {rows.length === 0 && <p className="text-sm text-[#888888]" data-testid="pioneer-log-empty">No permission changes recorded yet.</p>}
      {rows.length > 0 && (
        <div className="overflow-x-auto admin-scroll max-h-[520px]">
          <table className="w-full text-left text-sm">
            <thead className="sticky top-0 bg-[#1A1A1A]">
              <tr className="font-grotesk text-[10px] uppercase tracking-[0.2em] text-[#C9A84C]">
                <th className="pb-2 pr-4">Timestamp</th><th className="pb-2 pr-4">Admin · session</th><th className="pb-2 pr-4">Change</th><th className="pb-2 pr-4">Target</th><th className="pb-2 pr-4">Before</th><th className="pb-2">After</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-[#262626] align-top hover:bg-[#202020]" data-testid={`pioneer-log-row-${r.id}`}>
                  <td className="py-2 pr-4 whitespace-nowrap text-[#D4D4D4]">{fmtTs(r.ts)}</td>
                  <td className="py-2 pr-4"><div className="text-[#F5F5F5]">{r.admin_email}</div><div className="font-mono text-[11px] text-[#888888]">sess {r.session}{r.ip ? ` · ${r.ip}` : ""}</div></td>
                  <td className="py-2 pr-4 text-[#C9A84C] whitespace-nowrap">{ACTION_LABEL[r.action] || r.action}</td>
                  <td className="py-2 pr-4 font-mono text-[12px] text-[#D4D4D4]">{r.target}</td>
                  <td className="py-2 pr-4 text-[#888888] max-w-[220px] truncate" title={fmtVal(r.before)}>{fmtVal(r.before)}</td>
                  <td className="py-2 text-[#F5F5F5] max-w-[220px] truncate" title={fmtVal(r.after)}>{fmtVal(r.after)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
